export interface AccesoApagado {
  tenantId: string;
  empresa: string;
  rol: string;
}

/**
 * Lo que se le dice a la plataforma al restaurar una cuenta: los accesos NO vuelven solos
 * (decisión de Sebastián). Si quedó alguno apagado, se nombra la empresa y se dice por dónde
 * devolverlo: el «Volver a dar acceso» de la ficha de la persona. `undefined` = nada que avisar.
 */
export function avisoDePersonaRestaurada(accesos: AccesoApagado[] | undefined): string | undefined {
  if (!accesos || accesos.length === 0) return undefined;
  const empresas = accesos.map((a) => a.empresa).join(', ');
  return accesos.length === 1
    ? `Su acceso a ${empresas} sigue apagado: no vuelve solo. Devolvelo desde su ficha, con «Volver a dar acceso».`
    : `Sus accesos a ${empresas} siguen apagados: no vuelven solos. Devolvelos desde su ficha, con «Volver a dar acceso».`;
}
